import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { axios } from '#api/axios';
import { useGetQnaCommunityQuery } from '#api/community';
import {
  GetCoachProfileWriteList,
  useGetCoachProfileWriteListQuery
} from '#api/accounts';

import { useUserInfo } from '#providers/UserInfo';

import Header from './header';
import ProfileList from './ProfileList';
import Section from './section';
import Progress from './ProfileProgress';
import SelectTag from 'src/refactor_components/common/SelectTag';

import { PROFILE_LIST_INFO } from './ProfileList/constant';
import { TrainerWhiteListData } from './constant';
import { truncateText } from 'src/refactor_shared/lib/truncateText';

import Next_Arrow_Icon from './icon/next_arrow_icon';
import { isUser } from 'src/refactor_shared/util/isUser';
import EventBanner from '#assets/images/event_banner.svg';

type ThreadType = {
  id: string;
  writerId: string;
  category: string;
  sequence: number;
  title: string;
  createdAt: string;
  image: string | null;
  name: string;
  startAthletic: string;
};

const MainPage = () => {
  const [threadSelectvalue, setThreadSelectvalue] = useState('likes');
  const [informationSelectvalue, setInformationSelectvalue] = useState('likes');

  const { userInfo, isLogIn } = useUserInfo();

  const { data: threads } = useQuery({
    queryKey: ['get-home-trainer-community', threadSelectvalue],
    queryFn: async () =>
      await axios.get<Array<ThreadType>>('/consumer/home/questions/trainer', {
        params: {
          sort: threadSelectvalue
        }
      }),
    select: ({ data }) => data,
    keepPreviousData: true
  });

  const { data: informationCommunityData } = useQuery({
    queryKey: ['get-information-community-home', informationSelectvalue],
    queryFn: async () =>
      await axios.get<Array<ThreadType>>('/consumer/home/questions/health', {
        params: {
          sort: informationSelectvalue
        }
      }),
    select: ({ data }) => data,
    keepPreviousData: true
  });

  // const { data: informationCommunityData } = useGetUserCommunityQuery(false, 4);
  const { data: qnaCommunityData } = useGetQnaCommunityQuery(true);
  const { data: getCoachProfileWriteList } = useGetCoachProfileWriteListQuery(
    userInfo?.id || ''
  );

  const isCompeleted = () => {
    const stepLength = PROFILE_LIST_INFO.length;
    const compeleteCount = PROFILE_LIST_INFO.filter(
      info =>
        getCoachProfileWriteList?.[
          info.type as keyof GetCoachProfileWriteList
        ] === true
    ).length;

    return stepLength / compeleteCount === 1 ? true : false;
  };

  return (
    <>
      <div className="w-full h-[100vh]">
        <Header />
        <div className="px-[20px] pb-103 flex flex-col gap-40 pt-24">
          {isUser() ? (
            <>
              {isCompeleted() ? null : (
                <Section sectionTitle="프로필 완성하고 신규 회원 창출하기">
                  <Progress compeleteData={getCoachProfileWriteList} />
                  <div className="flex gap-20 overflow-auto">
                    <ProfileList
                      getCoachProfileWriteList={getCoachProfileWriteList}
                    />
                  </div>
                </Section>
              )}
            </>
          ) : null}

          <Section sectionTitle="인기 트레이너">
            <div className="flex gap-8 overflow-x-auto">
              {TrainerWhiteListData.map(trainer => (
                <Link
                  key={trainer.id} // 각 Trainer에 고유한 ID 추가
                  to={`/trainer/${trainer.id}`}
                  className="flex flex-col gap-12 cursor-pointer"
                >
                  <div className="w-140 h-140 bg-[#24222A] text-[black] rounded-12">
                    <img
                      src={trainer.profileImage}
                      className="object-cover w-full h-full rounded-12"
                    />
                  </div>
                  <div className="flex flex-col gap-8">
                    <p className="text-[#C9C7D1] font-semibold text-16">
                      {trainer.name}
                    </p>
                    <div className="text-[16px] font-normal text-[#8E899F]">
                      {truncateText(trainer.introduce, 10)}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </Section>
          <div className="flex items-center justify-center">
            <Link
              to="/event/1"
              className="py-17 bg-gradient-to-b from-[#089B7A] to-[#03352A] rounded-8 w-full flex justify-center items-center"
            >
              <img src={EventBanner} />
            </Link>
          </div>
          <Section sectionTitle="회원들의 고민">
            <div className="flex gap-12 overflow-auto">
              {qnaCommunityData
                ? qnaCommunityData.slice(0, 5).map(value => (
                    <div className="flex gap-[12px]" key={value.id}>
                      <div className="w-280 bg-[#24222A] rounded-12 p-20 flex flex-col gap-40 justify-between">
                        <div>
                          <p className="pb-4 text-[#9170F2]">
                            {PARSE_CATEGORY[value.category]}
                          </p>
                          <p>{value.title}</p>
                        </div>
                        <Link
                          to={`/community/qna/${value.id}`}
                          className="text-center py-12 w-full border border-solid border-[#4D495A] rounded-8"
                        >
                          답변하기
                        </Link>
                      </div>
                    </div>
                  ))
                : null}
            </div>
          </Section>

          <Section
            sectionTitle="트레이너 이야기"
            rightContent={
              <Link
                to="/trainer-community"
                className="flex items-center h-16 gap-4 text-[#8E899F]"
              >
                <span className="text-[12px]">전체보기</span>
                <Next_Arrow_Icon />
              </Link>
            }
          >
            <SelectTag
              selectedValue={threadSelectvalue}
              setSelectedValue={setThreadSelectvalue}
              selectList={[
                { label: '🔥추천수 높은', value: 'likes' },
                { label: '최근 올라온', value: 'recent' }
              ]}
            />
            <div>
              {threads &&
                threads.map(data => (
                  <Link
                    key={data.id}
                    to={`/trainer-community/${data.id}`}
                    className="h-45 border-solid border-b border-[#1F1E25] flex gap-19 items-center"
                  >
                    <span className="text-[14px] text-[#8E899F] w-45">
                      {PARSE_CATEGORY[data.category]}
                    </span>
                    <span className="text-[16px] text-[#EAE8ED] font-normal line-clamp-1">
                      {data.title}
                    </span>
                  </Link>
                ))}
            </div>
          </Section>
          <Section
            sectionTitle="운동 가이드"
            rightContent={
              <Link
                to="/community/information"
                className="flex items-center h-16 gap-4 text-[#8E899F]"
              >
                <span className="text-[12px]">전체보기</span>
                <Next_Arrow_Icon />
              </Link>
            }
          >
            <SelectTag
              selectedValue={informationSelectvalue}
              setSelectedValue={setInformationSelectvalue}
              selectList={[
                { label: '🔥추천수 높은', value: 'likes' },
                { label: '최근 올라온', value: 'recent' }
              ]}
            />
            <div className="flex justify-start gap-[12.5px] overflow-x-auto">
              {informationCommunityData &&
                informationCommunityData.map(data => (
                  <Link
                    key={data.id}
                    to={`/community/information/${data.id}`}
                    className="flex flex-col flex-shrink-0 gap-8"
                  >
                    {data.image ? (
                      <img
                        src={data.image}
                        className="w-161 h-161 bg-[#24222A] text-[black] rounded-12 object-cover"
                      />
                    ) : (
                      <div className="w-161 h-161 bg-[#24222A] text-[black] rounded-12 object-cover border border-solid border-[#1F1E25]" />
                    )}
                    <div className="flex flex-col gap-4 overflow-x-scroll max-w-161 whitespace-nowrap">
                      <p className="text-[#C9C7D1] font-medium">{data.title}</p>
                      <span className="font-norma text-[#8E899F] text-[12px]">
                        {data.name} · {PARSE_CATEGORY[data.category]}
                      </span>
                    </div>
                  </Link>
                ))}
            </div>
          </Section>
        </div>
      </div>
    </>
  );
};

export default MainPage;

const PARSE_CATEGORY: Record<string, string> = {
  KNOWHOW: '노하우',
  DAILY: '일상',
  CONCERN: '고민',
  COLUMN: '칼럼',
  METHOD: '운동 방법',
  INJURY_REHABILITATION: '부상 / 재활',
  NUTRITION_DIET: '영양 / 식단',
  LOSE_WEIGHT_BULK_UP: '다이어트 / 벌크업',
  COMPETITION_BODY_PROFILE: '대회 / 바디 프로필'
};
